
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  SimpleReponseResult.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SimpleReponseResult.ts

export class SimpleReponseResult {

  // bool Ok
  public Ok: boolean=false;

  // string Message
  public Message?: string=null;

  // object ExtendDatas
  public ExtendDatas: unknown=null;

  // string StackTrace
  public StackTrace?: string=null;

  // int Id
  public Id: number=0;
}